import { Query } from 'graphql/generated/graphqlTypes';
import { generateMockLocation } from 'mocks/graphqlMocks/location';

export function mockedGetLocationsWithoutNestedResolversData(
  getLocationsForTenant: Query['getLocationsForTenant']
): Pick<Query, 'getLocationsForTenant'> {
  return { getLocationsForTenant };
}

export const mockedGetLocationsWithoutNestedResolversDataForQuery = mockedGetLocationsWithoutNestedResolversData([
  generateMockLocation({ id: 'TestGroup1', name: 'Test group 1' }),
  generateMockLocation({ id: 'TestGroup2', name: 'Test group 2' })
]);
